import React, {FC} from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import classNames from 'classnames';
import Button from 'components/Button';
import {HubSpotForm} from 'components/ContentPagesComponents/HubSpotForm';
import DynamicAsset from 'components/DynamicAsset';
import {BG} from 'constants/index';
import {Link} from 'gatsby';
import {useToggle} from 'hooks/useToggle';

import circlesLeft from './svgs/circlesLeft.svg';
import circlesRight from './svgs/circlesRight.svg';

import * as styles from './styles.module.scss';

export interface StepsReviewerProps {
	imageSrc: string;
	title: string;
	buttonLink?: string;
	buttonText: string;
	buttonForm?: string;
	children: React.ReactNode[];
	bg?: BG;
}

type StepsReviewerButtonProps = {
	buttonLink?: string;
	buttonText: string;
	buttonForm?: string;
}

const phonePreview = 'https://static.bodyspec.com/at/16/9e/169efeb5e1bc55b4';

const StepsReviewerButton: FC<StepsReviewerButtonProps> = ({buttonLink, buttonText, buttonForm}) => {
	const {open: show, toggle: toggleForm} = useToggle(false);
	if (buttonLink) {
		return (
			<Link to={buttonLink} className={styles.link}>
				<Button variant='primary' className={styles.button}>
					{buttonText}
				</Button>
			</Link>
		);
	}

	if (buttonForm) {
		const Form = HubSpotForm(buttonForm);
		return (
			<>
				<Button
					variant='primary'
					className={styles.button}
					onClick={toggleForm}
				>
					{buttonText}
				</Button>
				{show && (
					<Form show={show} onClose={toggleForm} />
				)}
			</>

		);
	}

	return null;
};

const StepsReviewer: FC<StepsReviewerProps> = ({
	imageSrc,
	title,
	children,
	buttonLink,
	buttonText,
	buttonForm,
	bg='transparent',
}) => (
	<div className={classNames({
		[styles.background]: true,
		[styles.light]: bg === BG.light,
		[styles.dark]: bg === BG.dark,
	})}>
		<Container className={styles.container} fluid>
			<Col className={styles.imageColumn}>
				<div className={classNames({
					[styles.middle]: bg === BG.light,
					[styles.light]: bg === BG.transparent || bg === BG.dark,
				})}>
					<DynamicAsset imageSrc={imageSrc} alt={phonePreview} className={styles.image} />
					<img src={circlesLeft as string} className={styles.circlesLeft} />
					<img src={circlesRight as string} className={styles.circlesRight} />
				</div>
			</Col>
			<Col className={styles.stepsColumn}>
				<h4 className={styles.title}>{title}</h4>
				<div className={styles.items}>
					{children}
					{children.map((_, i) => (
						<span className={styles.bullet} key={i}>
						</span>
					))}
					<div className={styles.vertical} style={{
						gridRowEnd: children.length * 2,
						gridColumnEnd: children.length * 2,
					}} />
				</div>
				{buttonText && (buttonLink || buttonForm) && (
					<StepsReviewerButton
						buttonLink={buttonLink}
						buttonText={buttonText}
						buttonForm={buttonForm}
					/>
				)}
			</Col>
		</Container>
	</div>
);

export default StepsReviewer;
